import React, { useState } from 'react';
import {
  View,
  Text,
  ScrollView,
  Image,
  TouchableOpacity,
  useColorScheme,
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';

const RecipeDetailScreen = ({ route, navigation }) => {
  const { recipeId } = route.params;
  const isDarkMode = useColorScheme() === 'dark';
  const [isSaved, setIsSaved] = useState(false);
  const [likeCount, setLikeCount] = useState(187);
  const [isLiked, setIsLiked] = useState(false);

  // 模拟食谱数据 - 实际应用中应基于recipeId获取
  const recipe = {
    id: recipeId,
    title: '高蛋白低脂早餐碗',
    content: '这款早餐碗富含蛋白质，低脂肪，能量充足，非常适合健身人群或减脂期间食用。',
    image: 'https://images.unsplash.com/photo-1494390248081-4e521a5940db?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
    tags: ['高蛋白', '低脂', '早餐'],
    user: {
      name: '营养师小王',
      avatar: 'https://randomuser.me/api/portraits/men/29.jpg',
      followers: 1256,
    },
    likes: 187,
    saves: 76,
    time: '3天前',
    cookTime: '15分钟',
    difficulty: '简单',
    servings: 2,
    nutrition: {
      calories: 320,
      protein: 28,
      carbs: 32,
      fat: 8,
      fiber: 6,
      sugar: 4,
    },
    ingredients: [
      {
        name: '全脂希腊酸奶',
        amount: '150克',
      },
      {
        name: '香蕉',
        amount: '1个',
      },
      {
        name: '混合浆果',
        amount: '100克',
      },
      {
        name: '燕麦',
        amount: '40克',
      },
      {
        name: '奇亚籽',
        amount: '1汤匙',
      },
      {
        name: '蛋白粉（可选）',
        amount: '1勺',
      },
      {
        name: '蜂蜜或枫糖浆',
        amount: '1茶匙',
      },
    ],
    steps: [
      '将香蕉切片，混合浆果洗净备用',
      '将希腊酸奶倒入碗中作为底层',
      '加入切好的香蕉片和浆果',
      '撒上燕麦和奇亚籽',
      '如需增加蛋白质含量，可混入一勺蛋白粉',
      '根据口味淋上少量蜂蜜或枫糖浆',
      '食用前轻轻搅拌即可',
    ],
    tips: [
      '可以前一晚准备好所有材料，第二天早上快速组装',
      '可根据个人口味调整水果种类',
      '燕麦可以换成格兰诺拉麦片增加口感',
      '控制糖分摄入的朋友可以不加蜂蜜',
    ],
  };

  const handleLike = () => {
    if (isLiked) {
      setLikeCount(likeCount - 1);
    } else {
      setLikeCount(likeCount + 1);
    }
    setIsLiked(!isLiked);
  };

  const handleSave = () => {
    setIsSaved(!isSaved);
  };

  return (
    <ScrollView 
      style={{ 
        flex: 1, 
        backgroundColor: isDarkMode ? '#1f2937' : '#f9fafb',
      }}
    >
      {/* 食谱图片 */}
      <View style={{ position: 'relative' }}>
        <Image
          source={{ uri: recipe.image }}
          style={{ width: '100%', height: 240 }}
        />
        
        {/* 返回按钮 */}
        <TouchableOpacity
          style={{
            position: 'absolute',
            top: 16,
            left: 16,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            borderRadius: 20,
            padding: 8,
          }}
          onPress={() => navigation.goBack()}
        >
          <Ionicons name="arrow-back" size={24} color="white" />
        </TouchableOpacity>
      </View>

      {/* 内容区域 */}
      <View style={{ padding: 16 }}>
        {/* 标题和标签 */}
        <Text style={{ 
          fontSize: 24, 
          fontWeight: 'bold',
          color: isDarkMode ? 'white' : '#1f2937',
          marginBottom: 8,
        }}>
          {recipe.title}
        </Text>

        <View style={{ flexDirection: 'row', flexWrap: 'wrap', marginBottom: 16 }}>
          {recipe.tags.map((tag, index) => (
            <View 
              key={index}
              style={{
                backgroundColor: isDarkMode ? '#4b5563' : '#f3f4f6',
                paddingHorizontal: 10,
                paddingVertical: 5,
                borderRadius: 20,
                marginRight: 8,
                marginBottom: 8,
              }}
            >
              <Text style={{ 
                fontSize: 12, 
                color: isDarkMode ? '#e0e0e0' : '#4b5563',
              }}>
                #{tag}
              </Text>
            </View>
          ))}
        </View>

        {/* 作者信息 */}
        <TouchableOpacity
          style={{ 
            flexDirection: 'row', 
            alignItems: 'center', 
            marginBottom: 16,
            backgroundColor: isDarkMode ? '#374151' : 'white',
            padding: 12,
            borderRadius: 12,
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 1 },
            shadowOpacity: 0.1,
            shadowRadius: 2,
            elevation: 2,
          }}
          onPress={() => {/* 导航到作者主页 */}}
        >
          <Image 
            source={{ uri: recipe.user.avatar }} 
            style={{ 
              width: 48, 
              height: 48, 
              borderRadius: 24,
              marginRight: 12, 
            }} 
          />
          <View style={{ flex: 1 }}>
            <Text style={{ 
              fontSize: 16,
              fontWeight: 'bold',
              color: isDarkMode ? 'white' : '#1f2937',
              marginBottom: 2,
            }}>
              {recipe.user.name}
            </Text>
            <Text style={{ fontSize: 14, color: isDarkMode ? '#d1d5db' : '#6b7280' }}>
              {recipe.user.followers} 粉丝
            </Text>
          </View>
          <TouchableOpacity
            style={{
              backgroundColor: '#2563eb',
              paddingHorizontal: 16,
              paddingVertical: 8,
              borderRadius: 20,
            }}
          >
            <Text style={{ color: 'white', fontWeight: '500' }}>关注</Text>
          </TouchableOpacity>
        </TouchableOpacity>

        {/* 食谱基本信息 */}
        <View style={{ 
          flexDirection: 'row', 
          justifyContent: 'space-between',
          backgroundColor: isDarkMode ? '#374151' : 'white',
          borderRadius: 12,
          padding: 16,
          marginBottom: 20,
          shadowColor: '#000',
          shadowOffset: { width: 0, height: 1 },
          shadowOpacity: 0.1,
          shadowRadius: 2,
          elevation: 2,
        }}>
          <View style={{ alignItems: 'center' }}>
            <Ionicons name="time-outline" size={20} color={isDarkMode ? '#d1d5db' : '#6b7280'} />
            <Text style={{ 
              color: isDarkMode ? 'white' : '#1f2937',
              fontWeight: 'bold',
              marginTop: 4,
              marginBottom: 2,
            }}>
              {recipe.cookTime}
            </Text>
            <Text style={{ fontSize: 12, color: isDarkMode ? '#d1d5db' : '#6b7280' }}>
              烹饪时间
            </Text>
          </View>
          
          <View style={{ alignItems: 'center' }}>
            <Ionicons name="speedometer-outline" size={20} color={isDarkMode ? '#d1d5db' : '#6b7280'} />
            <Text style={{ 
              color: isDarkMode ? 'white' : '#1f2937',
              fontWeight: 'bold',
              marginTop: 4,
              marginBottom: 2,
            }}>
              {recipe.difficulty}
            </Text>
            <Text style={{ fontSize: 12, color: isDarkMode ? '#d1d5db' : '#6b7280' }}>
              难度
            </Text>
          </View>
          
          <View style={{ alignItems: 'center' }}>
            <Ionicons name="restaurant-outline" size={20} color={isDarkMode ? '#d1d5db' : '#6b7280'} />
            <Text style={{ 
              color: isDarkMode ? 'white' : '#1f2937',
              fontWeight: 'bold',
              marginTop: 4,
              marginBottom: 2,
            }}>
              {recipe.servings}
            </Text>
            <Text style={{ fontSize: 12, color: isDarkMode ? '#d1d5db' : '#6b7280' }}>
              份量
            </Text>
          </View>
        </View>

        {/* 营养信息 */}
        <View style={{ marginBottom: 20 }}>
          <Text style={{
            fontSize: 18,
            fontWeight: 'bold',
            color: isDarkMode ? 'white' : '#1f2937',
            marginBottom: 12,
          }}>
            营养成分
          </Text>
          
          <View style={{ 
            backgroundColor: isDarkMode ? '#374151' : 'white',
            borderRadius: 12,
            padding: 16,
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 1 },
            shadowOpacity: 0.1,
            shadowRadius: 2,
            elevation: 2,
          }}>
            <View style={{ flexDirection: 'row', marginBottom: 16 }}>
              <View style={{ flex: 1, alignItems: 'center' }}>
                <Text style={{ 
                  color: isDarkMode ? '#d1d5db' : '#6b7280',
                  fontSize: 12,
                  marginBottom: 4,
                }}>
                  热量
                </Text>
                <Text style={{ 
                  fontWeight: 'bold',
                  fontSize: 16,
                  color: isDarkMode ? 'white' : '#1f2937',
                }}>
                  {recipe.nutrition.calories} kcal
                </Text>
              </View>
              <View style={{ flex: 1, alignItems: 'center' }}>
                <Text style={{ 
                  color: isDarkMode ? '#d1d5db' : '#6b7280',
                  fontSize: 12,
                  marginBottom: 4,
                }}>
                  蛋白质
                </Text>
                <Text style={{ 
                  fontWeight: 'bold',
                  fontSize: 16,
                  color: isDarkMode ? 'white' : '#1f2937',
                }}>
                  {recipe.nutrition.protein}g
                </Text>
              </View>
            </View>

            <View style={{ flexDirection: 'row', marginBottom: 16 }}>
              <View style={{ flex: 1, alignItems: 'center' }}>
                <Text style={{ 
                  color: isDarkMode ? '#d1d5db' : '#6b7280',
                  fontSize: 12,
                  marginBottom: 4,
                }}>
                  碳水
                </Text>
                <Text style={{ 
                  fontWeight: 'bold',
                  fontSize: 16,
                  color: isDarkMode ? 'white' : '#1f2937',
                }}>
                  {recipe.nutrition.carbs}g
                </Text>
              </View>
              <View style={{ flex: 1, alignItems: 'center' }}>
                <Text style={{ 
                  color: isDarkMode ? '#d1d5db' : '#6b7280',
                  fontSize: 12,
                  marginBottom: 4,
                }}>
                  脂肪
                </Text>
                <Text style={{ 
                  fontWeight: 'bold',
                  fontSize: 16,
                  color: isDarkMode ? 'white' : '#1f2937',
                }}>
                  {recipe.nutrition.fat}g
                </Text>
              </View>
            </View>

            <View style={{ flexDirection: 'row' }}>
              <View style={{ flex: 1, alignItems: 'center' }}>
                <Text style={{ 
                  color: isDarkMode ? '#d1d5db' : '#6b7280',
                  fontSize: 12,
                  marginBottom: 4,
                }}>
                  膳食纤维
                </Text>
                <Text style={{ 
                  fontWeight: 'bold',
                  fontSize: 16,
                  color: isDarkMode ? 'white' : '#1f2937',
                }}>
                  {recipe.nutrition.fiber}g
                </Text>
              </View>
              <View style={{ flex: 1, alignItems: 'center' }}>
                <Text style={{ 
                  color: isDarkMode ? '#d1d5db' : '#6b7280',
                  fontSize: 12,
                  marginBottom: 4,
                }}>
                  糖分
                </Text>
                <Text style={{ 
                  fontWeight: 'bold',
                  fontSize: 16,
                  color: isDarkMode ? 'white' : '#1f2937',
                }}>
                  {recipe.nutrition.sugar}g
                </Text>
              </View>
            </View>
          </View>
        </View>

        {/* 配料表 */}
        <View style={{ marginBottom: 20 }}>
          <Text style={{
            fontSize: 18,
            fontWeight: 'bold',
            color: isDarkMode ? 'white' : '#1f2937',
            marginBottom: 12,
          }}>
            配料 ({recipe.ingredients.length})
          </Text>
          
          <View style={{ 
            backgroundColor: isDarkMode ? '#374151' : 'white',
            borderRadius: 12,
            padding: 16,
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 1 },
            shadowOpacity: 0.1,
            shadowRadius: 2,
            elevation: 2,
          }}>
            {recipe.ingredients.map((ingredient, index) => (
              <View 
                key={index}
                style={{ 
                  flexDirection: 'row', 
                  justifyContent: 'space-between',
                  paddingVertical: 8,
                  borderBottomWidth: index < recipe.ingredients.length - 1 ? 1 : 0,
                  borderBottomColor: isDarkMode ? '#4b5563' : '#f3f4f6',
                }}
              >
                <Text style={{ color: isDarkMode ? 'white' : '#1f2937' }}>
                  {ingredient.name}
                </Text>
                <Text style={{ color: isDarkMode ? '#d1d5db' : '#6b7280' }}>
                  {ingredient.amount}
                </Text>
              </View>
            ))}
          </View>
        </View>

        {/* 步骤 */}
        <View style={{ marginBottom: 20 }}>
          <Text style={{
            fontSize: 18,
            fontWeight: 'bold',
            color: isDarkMode ? 'white' : '#1f2937',
            marginBottom: 12,
          }}>
            烹饪步骤
          </Text>
          
          <View style={{ 
            backgroundColor: isDarkMode ? '#374151' : 'white',
            borderRadius: 12,
            padding: 16,
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 1 },
            shadowOpacity: 0.1,
            shadowRadius: 2,
            elevation: 2,
          }}>
            {recipe.steps.map((step, index) => (
              <View 
                key={index}
                style={{ 
                  flexDirection: 'row', 
                  marginBottom: index < recipe.steps.length - 1 ? 12 : 0,
                }}
              >
                <View style={{ 
                  width: 24,
                  height: 24,
                  borderRadius: 12,
                  backgroundColor: '#2563eb',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginRight: 12,
                  marginTop: 2,
                }}>
                  <Text style={{ color: 'white', fontWeight: 'bold', fontSize: 12 }}>
                    {index + 1}
                  </Text>
                </View>
                <Text style={{ 
                  flex: 1,
                  color: isDarkMode ? 'white' : '#1f2937',
                  lineHeight: 20,
                }}>
                  {step}
                </Text>
              </View>
            ))}
          </View>
        </View>

        {/* 小贴士 */}
        <View style={{ marginBottom: 20 }}>
          <Text style={{
            fontSize: 18,
            fontWeight: 'bold',
            color: isDarkMode ? 'white' : '#1f2937',
            marginBottom: 12,
          }}>
            烹饪小贴士
          </Text>
          
          <View style={{ 
            backgroundColor: isDarkMode ? '#374151' : '#f0f9ff',
            borderRadius: 12,
            padding: 16,
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 1 },
            shadowOpacity: 0.1,
            shadowRadius: 2,
            elevation: 2,
          }}>
            {recipe.tips.map((tip, index) => (
              <View 
                key={index}
                style={{ 
                  flexDirection: 'row', 
                  marginBottom: index < recipe.tips.length - 1 ? 10 : 0,
                }}
              >
                <Ionicons 
                  name="bulb-outline" 
                  size={16} 
                  color="#3b82f6" 
                  style={{ marginRight: 8, marginTop: 2 }} 
                />
                <Text style={{ 
                  flex: 1,
                  color: isDarkMode ? 'white' : '#1f2937',
                }}>
                  {tip}
                </Text>
              </View>
            ))}
          </View>
        </View>
      </View>

      {/* 底部操作栏 */}
      <View style={{
        flexDirection: 'row',
        padding: 16,
        backgroundColor: isDarkMode ? '#374151' : 'white',
        borderTopWidth: 1,
        borderTopColor: isDarkMode ? '#4b5563' : '#f3f4f6',
      }}>
        <TouchableOpacity
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            marginRight: 20,
          }}
          onPress={handleLike}
        >
          <Ionicons 
            name={isLiked ? "heart" : "heart-outline"} 
            size={24} 
            color={isLiked ? "#ec4899" : (isDarkMode ? "#d1d5db" : "#6b7280")} 
            style={{ marginRight: 4 }}
          />
          <Text style={{ color: isDarkMode ? '#d1d5db' : '#6b7280' }}>
            {likeCount}
          </Text>
        </TouchableOpacity>

        <TouchableOpacity
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            marginRight: 20,
          }}
          onPress={() => {/* 评论功能 */}}
        >
          <Ionicons 
            name="chatbubble-outline" 
            size={22} 
            color={isDarkMode ? "#d1d5db" : "#6b7280"}
            style={{ marginRight: 4 }}
          />
          <Text style={{ color: isDarkMode ? '#d1d5db' : '#6b7280' }}>
            评论
          </Text>
        </TouchableOpacity>

        <TouchableOpacity
          style={{
            flexDirection: 'row',
            alignItems: 'center',
          }}
          onPress={() => {/* 分享功能 */}}
        >
          <Ionicons 
            name="share-social-outline" 
            size={22} 
            color={isDarkMode ? "#d1d5db" : "#6b7280"}
            style={{ marginRight: 4 }}
          />
          <Text style={{ color: isDarkMode ? '#d1d5db' : '#6b7280' }}>
            分享
          </Text>
        </TouchableOpacity>

        <View style={{ flex: 1 }} />

        <TouchableOpacity
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            backgroundColor: isSaved ? '#8b5cf6' : (isDarkMode ? '#4b5563' : '#f3f4f6'),
            paddingHorizontal: 16,
            paddingVertical: 8,
            borderRadius: 20,
          }}
          onPress={handleSave}
        >
          <Ionicons 
            name={isSaved ? "bookmark" : "bookmark-outline"} 
            size={18} 
            color={isSaved ? "white" : (isDarkMode ? "#d1d5db" : "#6b7280")}
            style={{ marginRight: 6 }}
          />
          <Text style={{ 
            color: isSaved ? "white" : (isDarkMode ? "#d1d5db" : "#6b7280"),
            fontWeight: isSaved ? 'bold' : 'normal',
          }}>
            {isSaved ? "已收藏" : "收藏"}
          </Text>
        </TouchableOpacity>
      </View>
    </ScrollView>
  );
};

export default RecipeDetailScreen; 